import React, { useEffect, useState } from 'react'
import { any, func, string } from 'prop-types'

import { Form, FormErrorHandler } from '../../Form'
import { Social } from '../Social'
import { SignUpInputs } from './SignUpInputs'

export const SignUpForm = ({ onSignUp, errors, handleRedirect, openChild, userType }) => {
  const [signUpStep, setSignUpStep] = useState(0)
  const [clearCaptcha, setClearCaptcha] = useState(false)

  useEffect(() => {
    if (errors?.email || errors?.password) {
      setSignUpStep(0)
      setClearCaptcha(true)
    }
  }, [errors])

  return (
    <>
      <Form
        initialValues={{
          email: '',
          password: '',
          passwordConfirmation: '',
          firstName: '',
          lastName: '',
          username: '',
          fundraiser: !(userType === 'donor'),
          captcha: null,
        }}
        onSubmit={onSignUp}
      >
        <FormErrorHandler errors={errors} />
        <SignUpInputs
          signUpStep={signUpStep}
          signUpErrors={errors}
          clearCaptcha={clearCaptcha}
          setClearCaptcha={setClearCaptcha}
          setSignUpStep={setSignUpStep}
        />
      </Form>
      {signUpStep === 0 && (
        <Social token={handleRedirect} openChild={openChild} fundraiser={!(userType === 'donor')} />
      )}
    </>
  )
}

SignUpForm.propTypes = {
  onSignUp: func,
  errors: any,
  handleRedirect: func,
  openChild: func,
  userType: string,
}
